<template>
  <a-card :bordered="false" title="发票审核">
    <div v-if="isSuccess == 1">
      <a-form>
        <search-header :col="3">
          <search-list>
            <a-form-item label="发票抬头" v-bind="searchItemLayout">
              <a-input v-model="queryParams.invoiceHeader" placeholder="请输入"></a-input>
            </a-form-item>
            <a-form-item label="抬头类型" v-bind="searchItemLayout">
              <a-select v-model="queryParams.headerType" allowClear style="width: 100%;" placeholder="请选择">
                <a-select-option :value="1">
                  企业
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="发票类型" v-bind="searchItemLayout">
              <a-select v-model="queryParams.invoiceType" allowClear style="width: 100%;" placeholder="请选择">
                <a-select-option v-for="item in invoiceType" :key="item.code" :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="申请时间" v-bind="searchItemLayout">
              <a-range-picker style="width: 100%;" format="YYYY-MM-DD" @change="onChange"/>
            </a-form-item>
            <a-form-item label="状态" v-bind="searchItemLayout">
              <a-select v-model="queryParams.status" allowClear style="width: 100%;" placeholder="请选择">
                <a-select-option v-for="item in invoiceStatus" :key="item.code" :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item style="margin-left:2%;">
              <a-button type="primary" @click="searchBtn">查询</a-button>
            </a-form-item>
          </search-list>
        </search-header>
      </a-form>
      <custom-page-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :queryParams="queryParams"
        :requestPromise="loadPromise"
      >
        <span slot="headerType" slot-scope="rowItem">
          {{ rowItem.record.headerType == 1 ? '企业' : '' }}
        </span>
        <span slot="invoiceType" slot-scope="rowItem">
          {{ rowItem.record.invoiceType | invoiceTypeName }}
        </span>
        <span slot="action" slot-scope="rowItem">
          <a v-if="rowItem.record.status == 1" @click="goDetail(rowItem.record.id)">审核申请</a>
          <a v-if="rowItem.record.status == 2" @click="goDetail(rowItem.record.id)">查看详情</a>
        </span>
      </custom-page-table>
    </div>
  </a-card>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'
import userHelper from '../../../utils/helper/userHelper'
import { ACCESS_CLOUD_TOKEN } from '@/store/mutation-types'
import { mapActions } from 'vuex'

export default {
  name: 'AuditInvoice',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '申请时间',
          dataIndex: 'createTime'
        },
        {
          title: '发票抬头',
          dataIndex: 'invoiceHeader'
        },
        {
          title: '金额',
          dataIndex: 'invoiceAmount'
        },
        {
          title: '抬头类型',
          dataIndex: 'headerType',
          scopedSlots: { customRender: 'headerType' }
        },
        {
          title: '发票类型',
          dataIndex: 'invoiceType',
          scopedSlots: { customRender: 'invoiceType' }
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getOrderListPromise(params),
      invoiceStatus: [],
      invoiceType: [],
      isSuccess: 0
    }
  },
  created() {
    this.getCloudCode()
  },
  mounted() {
    this.invoiceType = this.getAppConstants().getInvoiceType()
    this.invoiceStatus = this.getAppConstants().getInvoiceStatus()
  },
  methods: {
    ...mapActions(['GetCloudToken']),
    //获取云仓token
    getCloudCode() {
      if (!this.$ls.get(ACCESS_CLOUD_TOKEN)) {
        const userInfo = this.$store.getters.userInfo
        let merchantId = userInfo.merchantId
        const childAccountId = userInfo.account && userInfo.account > 3 ? userInfo.account : 0
        let platformId = this.getPlatformConfig().platformId
        let validationKey = userHelper.getCloudMD5Code(String(merchantId), String(platformId))
        let parmas = {
          merchantOppId: merchantId,
          platformId: platformId,
          validationKey: validationKey,
          childAccountId: childAccountId
        }
        this.GetCloudToken(parmas)
          .then(res => {
            this.isSuccess = 1
          })
          .catch(err => {
            this.$message.error('登录失败')
          })
      } else {
        this.isSuccess = 1
      }
    },
    // 获取表格数据接口
    getOrderListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices()
        .getCloudUserService()
        .post('invoice/v2/getAuditInvoiceList', params)
    },
    //搜索
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    //跳转详情
    goDetail(id) {
      this.$router.push({
        name: 'InvoiceDetails',
        query: {
          id: id
        }
      })
    },
    //日期传参
    onChange(value, dateString) {
      this.queryParams.applyStartTime = dateString[0]
      this.queryParams.applyEndTime = dateString[1]
      this.getLogUtils().logWithTag('this.queryParams.applyStartTime', this.queryParams.applyStartTime)
      this.getLogUtils().logWithTag('this.queryParams.applyEndTime', this.queryParams.applyEndTime)
    }
  }
}
</script>

<style scoped>
</style>